import React from 'react';
import { Color } from '../../../themes/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';

function getBorder(border: string, theme: any) {
  const borderColor = theme.palette.brand[border];
  return borderColor ? `1px solid ${borderColor}` : 'none';
}

const useStyles = makeStyles((theme: any) => ({
  container: {
    position: 'relative',
    borderRadius: theme.spacing(1),
    border: ({ border }: any) => getBorder(border, theme),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    backgroundColor: 'white',
  },
}));

export default function ContainerWithBorder({
  border = Color.GREEN_DEEP,
  ...props
}) {
  const classes = useStyles({ border });

  return (
    <div className={classes.container + ' ' + (props.className || '')}>
      {props.children}
    </div>
  );
}
